/**
 * Contains the interfaces used for change notification.
 */

export interface EntityUpdated<T> {
    type: 'UPDATE',
    entity: T
}

export interface EntityDeleted {
    type: 'DELETE',
    entityId: number
}

export interface EntityTransferred {
    type: 'TRANSFER',
    entityId: number
}

export type ChangeEvent<T> = EntityUpdated<T> | EntityDeleted | EntityTransferred;

export function entityChanged<T>(entity: T): EntityUpdated<T> {
    return {
        type: 'UPDATE',
        entity
    }
}

export function entityDeleted(entityId: number): EntityDeleted {
    return {
        type: 'DELETE',
        entityId
    }
}

/**
 * This occurs when an entity is transferred, meaning it may not be visible any more.
 * @param entityId the entity that was transferred
 * @returns 
 */
export function entityTransferred(entityId: number): EntityTransferred {
    return {
        type: 'TRANSFER',
        entityId
    }
}
